import { render } from "./que4.vue?vue&type=template&id=d2fc3ac6"
import script from "./que4.vue?vue&type=script&lang=js"
export * from "./que4.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__